import React from 'react';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';


const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),
    },
    title: {
        flex: '1 1 100%',
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "28px",
        lineHeight: "90px",
        color: "#222747",
    },
    searchForm: {
        width: "100%",
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
    },
    searchButton: {
        color: "#FFF",
        padding: "15px",
        fontSize: "18px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "unset",
        transition: "background 0.25s",
        border: "2px solid #222747",
        "&:hover": {
            background: "none",
            color: "#222747",
        },
        width: "100%",
    },
    searchInput: {
        width: "100%",
    },
    gridItem: {
        margin: theme.spacing(1),
    }
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { searchTerm, handleSearchTopic, handleSearchSubmit, clearSearchFilter } = props;

    return (
        <>
            <Grid container wrap="wrap" alignItems="center" justify="space-between">
                <form className={classes.searchForm} onSubmit={handleSearchSubmit}>
                    <Grid item xs={12} sm={6} md={7} className={classes.gridItem}><TextField id="search-term" label="Search" variant="outlined" onChange={handleSearchTopic} className={classes.searchInput} value={searchTerm} /></Grid>
                    <Grid item xs={12} sm={2} className={classes.gridItem}><Button type="submit" variant="contained" className={classes.searchButton}>Search</Button></Grid>
                    <Grid item xs={12} sm={2} className={classes.gridItem}><Button onClick={clearSearchFilter} variant="contained" className={classes.searchButton}>Clear Search</Button></Grid>
                </form>
            </Grid>
            <Toolbar className={classes.root}>
                <Typography className={classes.title} variant="h1" id="tableTitle" component="div">
                    Topic Management
                </Typography>
            </Toolbar>
        </>
    );
};

export default EnhancedTableToolbar;